module.exports = __webpack_public_path__ + "img/684761f.png";